<template>
    <div class="w-100">
      <Tables ref="tableRelatorioPivsQMA"
                  :columns= columnQMA
                  :showSearch="false"
                  :showPrint="false"
                  :newHeaderStatus="true"
                  :showDownload="false"
                  :showFullscreen="false"
                  v-on:Load="onLoad"
                  style="font-family: 'Segoe UI'">
                  <tr v-for="(obj,index) in dataRelatoioQma" :key="index">
                  <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.codQma != null ? obj.codQma: 'N/D'" />
                  <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.revisao != null ? obj.revisao: 'N/D'" />
                  <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.servicos != null ?  obj.servicos :  'N/D'" />
                  <TableColumn v-on:Edit="onSelect(obj)"
                    :status="1"
                    :newState="true" :colorStatus="obj.colorBackgroundStatusQma"
                    :descriptionNewStatus="obj.statusQMADescricao"
                    :fontColorStatus="obj.colorFontStatusQma"
                    style="font-weight: bold;"/>
                  <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.codigoObra"></TableColumn>
                  <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.codigoReferencia"></TableColumn>
                  <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.responsavel != null ? obj.responsavel: 'N/D'" />
                  <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.dataCriacao != null ? obj.dataCriacao : 'N/D'" />
                  <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.dataAprovacao != null && obj.dataAprovacao != '' ? obj.dataAprovacao : 'N/D'" />
                  </tr>
                  <template #ButtonsAprova>
                  <div class="buttons-table-action">
                      <button class="btn-generate-lote" @click="gerarPDF()"><i class="fas fa-file-pdf"></i> EXPORTAR PDF</button>
                  </div>
                  </template>

      </Tables>
      <QmaReportPDF :report="report" ref="refQmaPdf" :filtros="dadosFiltro" :formSearch="formSearch" :dataRelatoioQma="dataRelatoioQma" :contagemPendentes="contagemPendentes" :dataRelatoioQmaLength="dataRelatoioQmaLength"></QmaReportPDF>
     </div>

  </template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import QmaReportPDF from '@/views/private/qma/qmaReport/components/qmaReportTable/components/qmaReportPdf/qmaReportPdf.vue'
import reportQmaRepository from '@/shared/http/repositories/business/qmaReportRepository.js'
// import aprReport from '@/shared/http/repositories/business/aprReport'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'qmaReportPivsTable',
  components: {QmaReportPDF},
  mixins: [ActionsForm],
  props: ['report'],
  data () {
    return {
      columnQMA: ['CÓDIGO PIVS', 'REVISÃO', 'ATIVIDADE', 'STATUS', 'Código Obra', 'Descrição Obra', 'RESPONSÁVEL', 'DATA DE APLICAÇÃO', 'DATA APROVAÇÃO'],
      dataRelatoioQma: [],
      formSearch: {
        Fluxo: this.report,
        numeroQma: null,
        ResponsavelId: null,
        TemplateItemAvaliacaoId: null,
        DataInicioAPR: null,
        DataFimAPR: null,
        ObraId: null
      },
      dadosFiltro: {},
      quantitativosPDF: {},
      contagemPendentes: 0,
      dataRelatoioQmaLength: 0
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      loading.push()
      reportQmaRepository.GetAllQmaReport(this.$refs.tableRelatorioPivsQMA.pagingLimit, this.$refs.tableRelatorioPivsQMA.pagingIndex, this.formSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableRelatorioPivsQMA.LoadAllByData(Response)
          this.dataRelatoioQma = Response.data.data
          this.dataRelatoioQmaLength = Response.data.data.length
          if (Response.data.data.length > 0) {
            this.contagemPendentes = this.dataRelatoioQma.filter(item => item.statusQma <= 1).length
            this.dadosFiltro = Response.data.data[0].filtrosAplicados
            this.$emit('dataRelatoioQmaLength', this.dataRelatoioQmaLength)
            this.$emit('contagemPendentes', this.contagemPendentes)
          } else {
            this.contagemPendentes = 0
            this.$emit('dataRelatoioQmaLength', this.dataRelatoioQmaLength)
            this.$emit('contagemPendentes', this.contagemPendentes)
          }
        })
        .catch(Erro => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    gerarPDF () {
      this.$refs.refQmaPdf.dataRelatoioQma = this.dataRelatoioQma
      this.$refs.refQmaPdf.generatePDF()
    }
  }
}

</script>

    <style scoped>
    .btn-generate-lote {
        height: 2rem;
        padding: 0 1rem;
        background: #008144;
        color: white;
        border-radius: 4px;
        border: none;
        font-size: 12px;
    }
    .btn-generate-lote:hover{
        background: #024d2a;
    }
    .status-pill-wip{
    display: flex;
    font-size: 12px !important;
    padding: 1rem;
    width: 12rem;
    height: 30px;
    color: #6a6a6a;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #c0c0c0;
}
.status-pill-aproved {
    display: flex;
    font-size: 12px !important;
    padding: 1rem;
    width: 12rem;
    height: 30px;
    color: #133B1A;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #CBE9CF;
}
.status-pill-waiting {
    display: flex;
    font-size: 12px !important;
    padding: 1rem;
    width: 12rem;
    height: 30px;
    color: #003789;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #D4EEFD;
}
.status-pill-reproved {
    display: flex;
    font-size: 12px !important;
    padding: 1rem;
    width: 12rem;
    height: 30px;
    color: #AB0101;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
}
    </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaReport/qmaReportPivs/components/qmaReportPivsTable/qmaReportPivsTable.vue